export const LOGOUT = require('src/component/api/helper/apiHelper').logout;
